// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// required for modal close
// but makes problem with showing calendar when is on
// dodat u a tag ukoliko treba iskljucit turbolinks na neki klick
// data-turbolinks="false"

// require("flatpickr/dist/themes/airbnb.css")
// require("../css/flatpickr.min");

// require("datatables.net");
// require("datatables.net-bs4");
// require("datatables.net-bs4/css/dataTables.bootstrap4.min.css");

// // import flatpickr from "flatpickr";
// var flatpickr = require("../js/flatpickr");
// global.$ = global.flatpickr = flatpickr;
// window.$ = window.flatpickr = flatpickr;

// import ColorThief from "../js/color-thief.umd";
import "../css/static_pages.scss";

// import Swiper from "swiper";
// var Swiper = require("../js/swiper-bundle.min");
// global.$ = global.Swiper = Swiper;
// window.$ = window.Swiper = Swiper;

// var jQuery = require("jquery");

// global.$ = global.jQuery = jQuery;
// window.$ = window.jQuery = jQuery;
import "bootstrap";

require("@rails/ujs").start();
require("./general");

// import flatpickr from "flatpickr";

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
